module.exports = __webpack_public_path__ + "img/information_graphical.74cd991b.svg";